import { render, staticRenderFns } from "./MealViewer.vue?vue&type=template&id=6dc6d78e&"
import script from "./MealViewer.vue?vue&type=script&lang=js&"
export * from "./MealViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports